import React, { Component } from "react";
import UserForm from "./user_form";
import { Col, Row } from "react-bootstrap";
import LoggedOutFrame from "../../lib/logged_out_frame";
import { parse } from "querystring";
import get from "lodash/get";
import { onCaptchaReady } from "../../../lib/captcha";
import UserRoles from "../../../constants/roles";

class SignUpPage extends Component {
  state = {
    submitEnabled: false,
  };

  componentDidMount() {
    window.scrollTo({ top: 0, left: 0 });
    onCaptchaReady(() => {
      this.setState({ submitEnabled: true });
    });
  }

  signUp = formData => {
    formData.firstName = formData.fname;
    formData.lastName = formData.lname;

    this.props.signUp(
      {
        ...formData,
        role: this.props.forRole || UserRoles.Creator,
      },
      this.props.forRole
    );
  };

  getInitialValues = () => {
    var queryString = window.location.search;
    if (queryString[0] === "?") {
      queryString = queryString.substring(1);
    }
    var query = parse(queryString);

    return {
      email: get(query, "email"),
    };
  };

  getSubtitle = () => {
    if (this.props.forRole === UserRoles.Sponsor) {
      return "Are you a listener looking to sponsor podcasts by donating or subscribing to their exclusive content? Fill out your name, email, \
      and a password to create your listener account. Your name and email will be shared with the podcasts you subscribe to.";
    }

    return (
      <div>
        Are you a Podcaster ready to host and distribute your show on RedCircle? Fill in your name,
        email, and a password to create your account. If you're not a Podcaster, please sign up
        through the
        <a href="https://app.redcircle.com/sign-up/advertiser"> Advertiser Sign Up </a> or
        <a href="https://app.redcircle.com/sign-up/sponsor"> Listener Sign Up </a> instead.
      </div>
    );
  };

  getTitle = () => {
    if (this.props.forRole === UserRoles.Sponsor) {
      return "Listener Account Sign Up";
    }

    return "Podcaster Account Sign Up";
  };

  render() {
    var { user, isLoading, validationErrors } = this.props;

    return (
      <LoggedOutFrame title={this.getTitle()} subTitle={this.getSubtitle()}>
        <Row className="sign-up-row">
          <Col xs={12} md={6} mdOffset={3}>
            <UserForm
              onSubmit={this.signUp}
              user={user}
              initialValues={this.getInitialValues()}
              isLoading={isLoading}
              validationErrors={validationErrors}
              mode="create"
              submitEnabled={this.state.submitEnabled}
              password={this.props.password}
            />
            <div className="user-form__fine-print">
              By signing up, you agree to our{" "}
              <a href="https://redcircle.com/terms">Terms of Service</a> and{" "}
              <a href="https://redcircle.com/privacy">Privacy Policy</a>. This site is protected by
              reCAPTCHA and the Google{" "}
              <a href="https://policies.google.com/privacy">Privacy Policy</a> and{" "}
              <a href="https://policies.google.com/terms">Terms of Service</a>{" "}
            </div>
          </Col>
        </Row>
      </LoggedOutFrame>
    );
  }
}

export default SignUpPage;
